export default __webpack_public_path__ + "static/media/rewards.68e7a89a.png";